module.exports = __webpack_public_path__ + "static/media/need-help-banner-desktop.e91339a2.webp";